import { gql } from '@apollo/client';

const LastProfileUsedQuery = gql`
  query LastProfileUsed {
    lastProfileUsed: warRoomSuggestedActivityType
  }
`;

export default LastProfileUsedQuery;
